var Language = {
    FR: 'fr',
    EN: 'en',
};
export default Language;
